module.exports = __webpack_public_path__ + "static/media/souhoola.3053520b.png";